import { getPagePath, trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import { Mediator } from '@spotahome/soyuz-mediator';
import { OPEN_INFORMATION_MODAL } from '@spotahome/ui-library/src/tenant/components/utils/constants';
import { Button, InfoBanner } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

const openCancellationPoliciesSimplifiedModal = ({
  fullscreenOnMobile = false
} = {}) => {
  Mediator.publish(OPEN_INFORMATION_MODAL, {
    title: trans('cancellation.policies.title'),
    body: (
      <>
        <div className="cancellation-policies__section">
          <h3 className="cancellation-policies__section-title">
            {trans(
              'listing.simplification.bottom.cancellation.modal.before-acceptance.title'
            )}
          </h3>
          <p className="cancellation-policies__section-content">
            {trans(
              'listing.simplification.bottom.cancellation.modal.before-acceptance.body'
            )}
          </p>
        </div>
        <hr className="cancellation-policies-simplified__divider" />
        <div className="cancellation-policies__section">
          <h3 className="cancellation-policies__section-title">
            {trans(
              'listing.simplification.bottom.cancellation.modal.after-flexible.title'
            )}
          </h3>
          <p className="cancellation-policies__section-content">
            {trans(
              'listing.simplification.bottom.cancellation.modal.after-flexible.intro'
            )}
          </p>
          <ul className="cancellation-policies__section-content">
            <li
              dangerouslySetInnerHTML={{
                __html: trans(
                  'listing.simplification.bottom.cancellation.modal.bullet.60days'
                )
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: trans(
                  'listing.simplification.bottom.cancellation.modal.bullet.30days'
                )
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: trans(
                  'listing.simplification.bottom.cancellation.modal.bullet.29days'
                )
              }}
            />
          </ul>
        </div>
        <InfoBanner
          closable={false}
          theme="warning"
          className="cancellation-policies__section"
          contentClassName="cancellation-policies__info-banner"
          content={
            <span
              dangerouslySetInnerHTML={{
                __html: trans(
                  'listing.simplification.bottom.cancellation.modal.fee-warning'
                )
              }}
            />
          }
          icon={<DSIcon name="warning" />}
        />
        <Button
          onClick={() =>
            SoyuzAnalytics.sendGA4Event('CancellationPoliciesRedesign', {
              action: 'SeeMore'
            })
          }
          className="cancellation-policies__link"
          color="link"
          href={getPagePath('help-center.cancellation-policies')}
          target="_blank"
        >
          {trans(
            'listing.simplification.bottom.cancellation.modal.view-full-terms'
          )}
        </Button>
      </>
    ),
    fullscreenOnMobile
  });
};

export default openCancellationPoliciesSimplifiedModal;
